import { useEffect, useState } from "react";
import {
  getOLTs,
  createOLT,
  updateOLT,
  testOLTConnection,
  pollOLT,
  getOLTStatus,
  deleteOLT,
} from "../api/olt.api";

const statusColor = (ok) => (ok ? "green" : "red");

const emptyForm = {
  name: "",
  ip_address: "",
  vendor: "huawei",
  snmp_community: "",
  snmp_port: 161,
  telnet_port: 23,
  telnet_user: "",
  telnet_password: "",
};

export default function OLTs() {
  const [olts, setOlts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [testingId, setTestingId] = useState(null);

  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);

  const loadOLTs = async () => {
    try {
      const data = await getOLTs();
      // añadimos testResult y pingTime vacíos
      setOlts(data.map((o) => ({ ...o, testResult: null, pingTime: null })));
    } catch (err) {
      console.error("Error cargando OLTs", err);
    }
  };

  useEffect(() => {
    loadOLTs();
  }, []);

  // CREAR / ACTUALIZAR
  const handleSubmitOLT = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editingId) {
        await updateOLT(editingId, form);
        setEditingId(null);
      } else {
        await createOLT(form);
      }
      setForm(emptyForm);
      setShowForm(false);
      loadOLTs();
    } catch (err) {
      console.error("Error guardando OLT", err);
      alert("Error guardando OLT");
    } finally {
      setLoading(false);
    }
  };

  // CARGAR FORMULARIO PARA EDICIÓN
  const handleEditOLT = (olt) => {
    setForm({
      name: olt.name,
      ip_address: olt.ip_address,
      vendor: olt.vendor,
      snmp_community: olt.snmp_community,
      snmp_port: olt.snmp_port,
      telnet_port: olt.telnet_port,
      telnet_user: olt.telnet_user,
      telnet_password: olt.telnet_password,
    });
    setEditingId(olt.id);
    setShowForm(true);
  };

  // TEST DE CONEXIÓN REAL
  const handleTestConnection = async (oltId) => {
    setTestingId(oltId);
    try {
      const result = await testOLTConnection(oltId);
      setOlts((prev) =>
        prev.map((olt) =>
          olt.id === oltId
            ? {
                ...olt,
                testResult: result.status === "ok",
                pingTime: result.pingTime,
              }
            : olt
        )
      );
    } catch (err) {
      console.error("Error test conexión", err);
      setOlts((prev) =>
        prev.map((olt) =>
          olt.id === oltId
            ? { ...olt, testResult: false, pingTime: null }
            : olt
        )
      );
    } finally {
      setTestingId(null);
    }
  };

  const handlePoll = async (oltId) => {
    try {
      await pollOLT(oltId);
      alert("Polling SNMP iniciado (Celery)");
    } catch (err) {
      console.error("Error polling", err);
    }
  };

  const handleRefreshStatus = async (oltId) => {
    try {
      const status = await getOLTStatus(oltId);
      setOlts((prev) =>
        prev.map((olt) =>
          olt.id === oltId ? { ...olt, ...status } : olt
        )
      );
    } catch (err) {
      console.error("Error leyendo estado", err);
    }
  };

  const handleDelete = async (oltId) => {
    if (!window.confirm("¿Estás seguro de eliminar esta OLT?")) return;
    try {
      await deleteOLT(oltId);
      setOlts((prev) => prev.filter((olt) => olt.id !== oltId));
    } catch (err) {
      console.error("Error eliminando OLT", err);
      alert("Error eliminando OLT");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Gestión de OLTs</h2>

      <button
        onClick={() => {
          setShowForm(!showForm);
          setEditingId(null);
          setForm(emptyForm);
        }}
      >
        ➕ {editingId ? "Editar OLT" : "Crear OLT"}
      </button>

      {showForm && (
        <form
          onSubmit={handleSubmitOLT}
          style={{
            marginTop: 20,
            padding: 20,
            border: "1px solid #ccc",
            maxWidth: 500,
          }}
        >
          <h3>{editingId ? "Editar OLT" : "Nueva OLT"}</h3>

          <input
            placeholder="Nombre"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />
          <input
            placeholder="IP"
            value={form.ip_address}
            onChange={(e) =>
              setForm({ ...form, ip_address: e.target.value })
            }
            required
          />
          <select
            value={form.vendor}
            onChange={(e) => setForm({ ...form, vendor: e.target.value })}
          >
            <option value="">--- Seleccione modelo OLT ---</option>

            <optgroup label="Huawei">
              <option value="huawei">Huawei MA5800</option>
              <option value="huawei_ma5600t">Huawei MA5600T</option>
              <option value="huawei_5608t">Huawei 5608T</option>
            </optgroup>
  
            <optgroup label="ZTE">
              <option value="zte">ZTE C320</option>
              <option value="zte_c300">ZTE C300</option>
              <option value="zte_c600">ZTE C600</option>
            </optgroup>            

          </select>
          <input
            placeholder="SNMP Community"
            value={form.snmp_community}
            onChange={(e) =>
              setForm({ ...form, snmp_community: e.target.value })
            }
            required
          />
          <input
            type="number"
            placeholder="Puerto SNMP"
            value={form.snmp_port}
            onChange={(e) =>
              setForm({ ...form, snmp_port: Number(e.target.value) })
            }
          />
          <input
            type="number"
            placeholder="Puerto Telnet"
            value={form.telnet_port}
            onChange={(e) =>
              setForm({ ...form, telnet_port: Number(e.target.value) })
            }
          />
          <input
            placeholder="Usuario Telnet"
            value={form.telnet_user}
            onChange={(e) => setForm({ ...form, telnet_user: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password Telnet"
            value={form.telnet_password}
            onChange={(e) =>
              setForm({ ...form, telnet_password: e.target.value })
            }
            required
          />

          <div style={{ marginTop: 10 }}>
            <button type="submit" disabled={loading}>
              {loading
                ? "Guardando..."
                : editingId
                ? "Actualizar OLT"
                : "Guardar OLT"}
            </button>
          </div>
        </form>
      )}

      <table width="100%" cellPadding="10" style={{ marginTop: 30 }}>
        <thead>
          <tr>
            <th>OLT</th>
            <th>IP</th>
            <th>Vendor</th>
            <th>Telnet</th>
            <th>SNMP</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {olts.map((olt) => (
            <tr key={olt.id}>
              <td>{olt.name}</td>
              <td>{olt.ip_address}</td>
              <td>{olt.vendor}</td>
              <td style={{ color: statusColor(olt.telnet_ok) }}>
                {olt.telnet_ok ? "OK" : "—"}
              </td>
              <td style={{ color: statusColor(olt.snmp_ok) }}>
                {olt.snmp_ok ? "OK" : "—"}
              </td>
              <td>
                <button
                  onClick={() => handleTestConnection(olt.id)}
                  disabled={testingId === olt.id}
                  style={{
                    backgroundColor:
                      olt.testResult === null
                        ? undefined
                        : olt.testResult
                        ? "green"
                        : "red",
                    color: olt.testResult !== null ? "white" : undefined,
                  }}
                >
                  {testingId === olt.id
                    ? "Probando..."
                    : olt.testResult === null
                    ? "Test"
                    : olt.testResult
                    ? `✅ OK (${olt.pingTime ?? "—"} ms)`
                    : "❌ Error (— ms)"}
                </button>

                <button
                  style={{ marginLeft: 6 }}
                  onClick={() => handlePoll(olt.id)}
                >
                  Poll
                </button>

                <button
                  style={{ marginLeft: 6 }}
                  onClick={() => handleRefreshStatus(olt.id)}
                >
                  Refresh
                </button>

                <button
                  style={{ marginLeft: 6, backgroundColor: "darkred", color: "white" }}
                  onClick={() => handleDelete(olt.id)}
                >
                  Eliminar
                </button>

                <button
                  style={{ marginLeft: 6, backgroundColor: "#f59e0b", color: "white" }}
                  onClick={() => handleEditOLT(olt)}
                >
                  Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
